import { Stack } from "@mui/material";
import { observer } from "mobx-react-lite";
import { StoreType } from "polotno/model/store";
import { figureElementSelected } from "../utils";
import { FigureEffectsEditor } from "./figureEditor/FigureEffectsEditor";
import { FigureStrokeEditor } from "./figureEditor/FigureStrokeEditor";
import { FillColorEditor } from "./shared/FillColorEditor";
import {
  FigureLayerElement,
  LayerElement,
} from "screens/designStudio/designStudioV2/types";

type FigureEditorProps = {
  store: StoreType;
};

export const FigureEditor = observer(({ store }: FigureEditorProps) => {
  const selection = store.selectedElements;
  const correctSelection = figureElementSelected(selection as LayerElement[]);

  if (!correctSelection) return null;

  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      gap={1}
    >
      <FillColorEditor elements={selection as FigureLayerElement[]} />
      <FigureStrokeEditor elements={selection as FigureLayerElement[]} />
      <FigureEffectsEditor elements={selection as FigureLayerElement[]} />
    </Stack>
  );
});
